var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.styleEx),attrs:{"src":require("../assets/spinner.svg"),"width":_vm.width,"height":_vm.width,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }